/**
 * Given a number, returns the ordinal version of that number.
 *
 * @param {Number} n The number to convert
 * @returns {String} The ordinal version of the number
 *
 * @public
 * @author Alex Kasemir and Connor Taylor
 *
 * @example
 * const o1 = getOrdinal(1);
 * console.log(o1); // 1st
 *
 * const o2 = getOrdinal(2);
 * console.log(o2); // 2nd
 */
var getOrdinal = function getOrdinal(n) {
  var s = ["th", "st", "nd", "rd"];
  var v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};
/** @component */


export default getOrdinal;